const initThemeListener = () => {
  const fav = document.getElementById('favicon');
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    fav.href = `${CDN_URL}/rebranding/eght-logo-bare-dark.svg`;
  }
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', ({ matches }) => {
      if (matches) {
        fav.href = `${CDN_URL}/rebranding/eght-logo-bare-dark.svg`;
      } else {
        fav.href = `${CDN_URL}/rebranding/eght-logo-bare-light.svg`;
      }
    });
}

export default initThemeListener;